import styled from "styled-components";
import * as Variable from "../../CSSVariables";

export const ApiErrorStyle = styled.div`
  border: 1px solid #ff000024;
  width: 90%;
  display: block;
  padding: 16px 16px;
  margin: 20px auto;
  border-radius: 6px;
  background-color: #ff000024;

  @media only screen and (min-width: ${Variable.mobile}) {
    width: 100%;
  }
`;
